import { render } from "./CargoList.vue?vue&type=template&id=68f5a700"
import script from "./CargoList.vue?vue&type=script&lang=js"
export * from "./CargoList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__